import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const reviews = [
  {
    name: 'Marie-Claire D.',
    rating: 5,
    text: "Un service exceptionnel ! Les bouquets sont toujours magnifiques et l'équipe est d'une gentillesse rare. Je recommande vivement Alma Fleur pour tous vos événements.",
    date: 'Il y a 2 semaines',
  },
  {
    name: 'Jean-Pierre M.',
    rating: 5,
    text: "Merci pour la décoration florale de notre mariage. C'était absolument parfait, au-delà de nos attentes. Un vrai travail d'artiste !",
    date: 'Il y a 1 mois',
  },
  {
    name: 'Sophie L.',
    rating: 5,
    text: 'Toujours des fleurs fraîches et de qualité. La livraison est rapide et soignée. Ma fleuriste préférée à Sion !',
    date: 'Il y a 3 semaines',
  },
  {
    name: 'Marc A.',
    rating: 5,
    text: "Des compositions florales originales et élégantes. L'équipe prend le temps d'écouter nos souhaits. Service impeccable.",
    date: 'Il y a 1 mois',
  },
];

export const ReviewsSection = () => {
  return (
    <section
      data-testid="reviews-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 mb-6"
          >
            <Star className="w-5 h-5 text-accent fill-accent" />
            <span className="font-serif text-2xl font-semibold text-primary">4.9</span>
            <span className="text-muted-foreground">/ 5</span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-primary tracking-tight"
          >
            Ce que disent nos clients
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-muted-foreground max-w-xl mx-auto"
          >
            193 avis Google · La satisfaction de nos clients est notre plus belle récompense.
          </motion.p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`review-card-${index}`}
              className="bg-[#F2F4F0] p-8 rounded-2xl relative"
            >
              {/* Quote Icon */}
              <Quote className="absolute top-6 right-6 w-10 h-10 text-primary/10" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-accent fill-accent" />
                ))}
              </div>
              
              {/* Review Text */}
              <p className="text-primary/80 leading-relaxed mb-6">
                "{review.text}"
              </p>
              
              {/* Author */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium text-primary">{review.name}</p>
                  <p className="text-sm text-muted-foreground">{review.date}</p>
                </div>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/120px-Google_2015_logo.svg.png"
                  alt="Google"
                  className="h-5 opacity-50"
                />
              </div>
            </motion.div>
          ))}
        </div>

        {/* Google Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="text-center mt-12"
        >
          <a
            href="https://www.google.com/maps/place/Alma+Fleur+SA"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-border hover:bg-secondary/50 transition-colors"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/120px-Google_2015_logo.svg.png"
              alt="Google"
              className="h-5"
            />
            <span className="text-muted-foreground">Voir tous les avis sur Google</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
